/**
 * @generated SignedSource<<09faf72363da64e8b09def8dd36ba195>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionMode = "FREE_CHAT" | "TOPIC" | "%future added value";
export type StartSessionInput = {
  characterId?: string | null | undefined;
  learnerId: string;
  mode: SessionMode;
  practiceItemId?: string | null | undefined;
  storyBookId?: string | null | undefined;
  topic?: string | null | undefined;
  utcOffsetMinutes?: number | null | undefined;
  vocabularyItemId?: string | null | undefined;
};
export type usePractiseStartMutation$variables = {
  input: StartSessionInput;
};
export type usePractiseStartMutation$data = {
  readonly startSession: {
    readonly session: {
      readonly id: string;
    };
  };
};
export type usePractiseStartMutation = {
  response: usePractiseStartMutation$data;
  variables: usePractiseStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartSessionPayload",
    "kind": "LinkedField",
    "name": "startSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePractiseStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePractiseStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "efdffe692b9bbf3a80b5e052814dd2bf",
    "id": null,
    "metadata": {},
    "name": "usePractiseStartMutation",
    "operationKind": "mutation",
    "text": "mutation usePractiseStartMutation(\n  $input: StartSessionInput!\n) {\n  startSession(input: $input) {\n    session {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed9d592368898a89e156eef996d5020e";

export default node;
